// Human copy for the `?oauth_error=` hint an OAuth callback (GitHub, Google)
// redirects the browser back to /login with — on denial, CSRF-state failure,
// unverified-email conflict, provider outage, or unconfigured. Provider-neutral
// so both the GitHub (T-0077) and Google (T-0079) legs share it. Returns null
// when the param is absent or unrecognized.
export function oauthErrorMessage(reason: string | null): string | null {
  switch (reason) {
    case null:
      return null;
    case 'access_denied':
      return 'Sign-in was cancelled. You can try again or use your email and password.';
    case 'bad_state':
    case 'missing_code':
      return "Sign-in couldn't be completed (the request expired or looked unsafe). Please try again.";
    case 'email_conflict':
      return 'That email already has an account, and the sign-in provider hasn’t verified it. Sign in with your email and password, or verify the email with your provider first.';
    case 'github_unconfigured':
    case 'google_unconfigured':
      return 'That sign-in method is not available right now. Please use your email and password.';
    case 'github_failed':
    case 'google_failed':
      return "We couldn't finish signing you in. Try again in a minute.";
    default:
      return 'Sign-in did not complete. Please try again.';
  }
}
